// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X8Zp","colBig":"styles_colBig__1I8Gy","colSmall":"styles_colSmall__1EH3f","shopifyNameWrapper":"styles_shopifyNameWrapper__1Q5Sf"};